module.exports = __webpack_public_path__ + "./assets/logoiLearn__9753ed7c63a3e7eca1a8f7a2e237a4dc.svg";